<template>
  <el-dialog title="" :visible="true" :show-close="false" width="790px" class="ts-modal cropper">    
    <button type="button" aria-label="Close" class="el-dialog__headerbtn" @click="onCloseDialog(null)">
      <i class="el-dialog__close el-icon el-icon-close"></i>
    </button>

    <div style="overflow: hidden;">
         <div>
        <h4><strong>Your privacy</strong></h4>

        <p>Your data is being scrunched with your colleagues' data, key facts about the aims of the business and how its processes work at the moment, and benchmarks of national research for your sector.  All these factors together will help your company fully understand the current and future needs of its workforce in terms of training, support, promotions and opportunities to grow.</p>
        <p>Only a few managers in your company can see your data, anyone else will just see the combined results of everyone's feedback without being able to identify who it is from.  If you would like to know who will see your personal response, we recommend contacting the person who invited you to take the survey.</p>
        <p>All the anonymous data produced on the platform (data that doesn't show any personal identifiers for individuals or the specific company) from all the different companies who use it then can be shared to help inform and rebuild the skills systems around the world, that's the difference we can make together!</p>
        <p><a href="/static/privacy_policy.pdf" download>Click here to download our privacy policy</a></p>
        <p>On top of all this, for our European users, as well as hosting your data in the EU, some or all of the data will sometimes be transferred and processed outside of the EEA.  The personal data given on the platform is protected equally under GDPR whether it is hosted in Europe or another country such as the USA; the platform still remains fully GDPR compliant.</p>

        <button @click="onCloseDialog(null)" class="ts-btn ts-btn-rounded ts-btn-secondary">Back</button>
    </div>

    </div>

  </el-dialog>
</template>

<script>
export default {
  methods: {
    onCloseDialog(done) {
      this.$router.go(-1);
    }    
  }
};
</script>

<style scoped>

</style>